exports = module.exports = require("../../../../employee/node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".carousel .slide {\n  background: transparent !important; }\n\n.swiper-pagination {\n  position: static !important; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!../lib/egov-ui-kit/components/Carousel/index.css
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!../lib/egov-ui-kit/components/Carousel/index.css
// module chunks = 504